import { getLocales } from '@change-corgi/config/locales';
import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_OG_IMAGE_RENDER = defineFcm('psf_og_image_render')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean', optional: true },
				backfill_enabled: { type: 'boolean', optional: true },
				locales: { type: 'array', optional: true, shape: { type: 'enum', values: getLocales() } },
			},
		}),
	)
	.withDefault({ enabled: false, backfill_enabled: false, locales: [] })
	.toConfig({
		owner: 'squad-platypus',
		scope: 'monorail',
		supportedGroups: { global: true },
		context: 'PSF OG image renders (psf_og_image photo tag)',
		description: `Gates the renders of the PSF OG image variants (photo tag psf_og_image) in change_production.
			"enabled" turns the publish, update and backfill renders on, for petitions in "locales" only.
			"backfill_enabled" pauses only the backfill and keeps the publish and update renders on.
			Separate from the psf_og_image link FCM, which gates the share link segment and the enrollment. See CHANGE-99397.`,
		template: { enabled: true, backfill_enabled: false, locales: ['en-US'] },
	});
